import { FC } from "react"
import clsx from "clsx"

interface ICheckBoxWrapperProps {
    htmlFor?: string
    title?: string
    label?: string
    required?: boolean
    className?: string
    inputClass?: string
    children?: React.ReactNode
}

export const CheckBoxLabel: FC<ICheckBoxWrapperProps> = ({
    htmlFor, title, label, required, className, children
}) => {
    if (!label)
        return <>{children}</>

    return <div title={title} className={clsx(className, "form-check")}>
        <label htmlFor={htmlFor}
            className={clsx("form-check-label fw-semibold fs-7 my-0", { "required": required })}>
            {label}
        </label>
        {children}
    </div>
}
